<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>会员积分明细</h3>
            </div>
            <div class="card-button">
              <el-button class="push-button"
                         @click="NvagetToLookMenber"
                         icon="iconfont icon-fanhui">返回基本信息</el-button>
            </div>
          </div>
          <div class="demo-input-suffix">
            <div class="JfNumber-flex"
                 style="margin-left: 50px">
              <p>当前可用积分</p>
              <p class="integrate-number">{{ allPoints }}</p>
            </div>
            <div class="JfNumber-flex">
              <p>待生效积分</p>
              <p class="integrate-number">{{ pendingPoints }}</p>
            </div>
            <div class="JfNumber-flex">
              <p>即将过期积分</p>
              <p class="integrate-number">
                {{ will_failure_points }}
              </p>
            </div>
          </div>
          <div>
            <!-- table列表 -->
            <Table @TouchTheBottom="TouchTheBottom"
                   :PagesData="paging"
                   :tableData="list.tbody"
                   :configTable="list.thead"
                   :config="list"></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetQueryCustPointsLogList } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data () {
    return {
      allPoints: "",
      pendingPoints: "",
      will_failure_points: "",
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "变更日期",
            prop: "chgDate",
          },
          {
            label: "积分",
            prop: "points",
          },
          {
            label: "变更类型",
            prop: "chgKindText",
          },
          {
            label: "业务单据号",
            prop: "bindSheetNo",
          },
          {
            label: "积分生效日期",
            prop: "startDate",
          },
          {
            label: "备注",
            prop: "chgRemark",
          },
          {
            label: "创建日期",
            prop: "createTime",
          },
        ],
        tbody: [],
      },
    };
  },
  methods: {
    ReturnCoupNameText (state) {
      let ReturnCoupNameText = "";
      switch (state) {
        case 0:
          ReturnCoupNameText = "销售积分";
          break;
        case 1:
          ReturnCoupNameText = "补积分（补积分）";
          break;
        case 2:
          ReturnCoupNameText = "补积分（CRM）";
          break;
        case 3:
          ReturnCoupNameText = "积分过期";
          break;
        case 4:
          ReturnCoupNameText = "营销积分";
          break;
        case 5:
          ReturnCoupNameText = "积分兑换";
          break;
        case 6:
          ReturnCoupNameText = "外部行为积分";
          break;
        case 7:
          ReturnCoupNameText = "积分兑换废弃";
          break;
      }
      return ReturnCoupNameText;
    },
    TouchTheBottom () {
      this.paging.page++;
      this.RGetQueryCustPointsLogList();
    },
    RGetQueryCustPointsLogList () {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetQueryCustPointsLogList(data).then((res) => {
        if (res.success) {
          this.allPoints = res.allPoints;
          this.pendingPoints = res.pendingPoints;
          this.will_failure_points = res.will_failure_points;
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.chgDate = this.renderTime(item.chgDate);
            item.startDate = this.renderTime(item.startDate);
            item.createTime = this.renderTime(item.createTime);
            item.chgKindText = this.ReturnCoupNameText(parseInt(item.chgKind));
          });
          this.list.tbody = this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    NvagetToLookMenber () {
      this.$router.push("/LookMember");
    },
    renderTime (date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  created () {
    this.RGetQueryCustPointsLogList();
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.JfNumber-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.integrate-number {
  margin-left: 20px;
  height: 40px;
  background: #f5f5f5;
  border: 1px solid #cccccc;
  width: 100px;
  text-align: center;
  line-height: 40px;
}
.demo-input-suffix {
  display: flex;
  align-content: center;
  justify-content: space-around;
  height: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
